// tutorial: překlady řetězců funkce překladu $t
// překlad chybových hlášení vee-validate
const cz = {
    'countryCode': 'cz_cz',
    'Accetto il regolamento fidelity e la privacy policy': 'Přijímám podmínky věrnostního programu a zásady ochrany osobních údajů',
    'Account creation': 'Vytvoření účtu',
    'Add address': 'Přidat adresu',
    'Address': 'Adresa',
    'Address label': 'Název adresy',
    'Address label placeholder': 'například: domů, práce...',
    'Amount': 'Množství',
    'Apply': 'Použit',
    'Apply Discount': 'Využít slevu',
    'Are you sure you want to delete this item from cart': 'Opravdu chcete odstranit tuto položku z košíku?',
    'Are you sure you want to move this item to wishlist?': 'Opravdu si přejete přidat tuto položku na seznam přání?',
    'articles': 'položky',
    'articles inside': 'přítomné položky',
    'Back': 'Zpět',
    'Back to cart': 'Zpět do košíku',
    'Back to shopping': 'Zpět k nakupování',
    'Back to store': 'Zpět do obchodu',
    'Billing address': 'Fakturační adresa',
    'Billing address is the same as the shipping address': 'Fakturační a dodací adresa jsou stejné',
    'Buy': 'Koupit',
    'Buy Now': 'Koupit hned',
    'Buy now, pay later': 'Koupit nyní, zaplatit později',
    'Cancel': 'Zrušit',
    'Cannot apply Gift Card': 'Dárkovou kartu nelze uplatnit',
    'Cannot apply glam card points': 'Nelze použít body        WE Card',
    'Card issuer authentication failed': 'Nepodařilo se ověřit vydavatele karty',
    'Cart': 'Košík',
    'Cart content': 'Obsah košíku',
    'Change': 'Změnit',
    'Change address': 'Změnit adresu',
    'Change e-mail': 'Změnit e-mail',
    'Change pickup point': 'Změňte místo vyzvednutí',
    'Check zip code': 'Zkontrolovat PSČ',
    'Choose a shipping method in order to proceed': 'Pro pokračování vyberte způsob dopravy',
    'Choose a store for the pick-up in order to proceed': 'Chcete-li pokračovat, vyberte prodejnu k vyzvednutí',
    'Choose a zipcode in order to proceed': 'Pokračujte výběrem PSČ',
    'City': 'Město',
    'Close': 'Zavřít',
    'Closed': 'Zatvoreno',
    'Color': 'Barva',
    'Complete your order': 'Dokončit objednávku',
    'Condizioni di vendita': 'Podmínky prodeje',
    'Confirm': 'Potvrdit',
    'Continue': 'Pokračovat',
    'Continue as guest': 'Pokračovat jako host',
    'Country': 'Země',
    'Coupon': 'Kupon',
    'Coupon Code': 'Slevový kód',
    'Credit Card': 'Platební karta',
    'Credit Card Number': 'Číslo karty',
    'data': 'data',
    'Date of birth': 'Datum narození',
    'Date of Birth': 'Datum narození',
    'dd/mm/yyyy': 'dd/mm/rrrr',
    'Delete': 'Odstranit',
    'Delivery:': 'Dodání:',
    'Description': 'Popis',
    'Do you have a discount code?': 'Máte slevový kód?',
    'Enter your Gift Card here': 'Sem zadejte svou dárkovou kartu',
    'do-login': 'Přihlásit se',
    'done': 'hotovo',
    'E-mail address': 'E-mail',
    'Edit': 'Upravit',
    'Edit address': 'Upravit adresu',
    'Edit Cart': 'Upravit košík',
    'Email': 'E-mail',
    'Email and telephone number': 'E-mail a telefonní číslo',
    'email-remainder': 'Odeslali jsme vám e-mail pro obnovu hesla. Klikněte na odkaz, který je v něm uveden.',
    'Empty credit card fields': 'Vyplňte prosím údaje platební karty',
    'Enter shipping address': 'Zadejte dodací adresu',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Error during payment authorization': 'Chyba během ověřování platby',
    'Error during registration': 'Chyba při registraci',
    'Error occurred while placing orde': 'Při podávání objednávky došlo k chybě',
    'Expire Date': 'Platnost',
    'Female': 'Žena',
    'Firstname': 'Jméno',
    'Forgot your password?': 'Nepamatujete si heslo?',
    'Free': 'Zdarma',
    'Friday': 'petak',
    'From': 'Z',
    'Gender': 'Pohlaví',
    'Gift Card': 'Poklon kartica',
    'Gift card and discount codes': 'Darovna kartica i kodovi za popust',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Sleva za body WE Card',
    'glamcard-bonusapplied': 'Byly použity body ({bonus}) WE Card',
    'Go to checkout': 'Přejít k pokladně',
    'Go to payment': 'Přejít k platbě',
    'Go to shipping': 'Idite na otpremu',
    'Go to summary': 'Přejít na shrnutí',
    'Home delivery cost': 'Cijena dostave do kuće',
    'How many points do you want to use?': 'Jakou část bonusu chcete využít?',
    'How much bonus do you want to use?': 'Kolik bodů chcete využít?',
    'I don\'t want to receive the invoice': 'Nepřeji si zaslat fakturu',
    'I tuoi contatti telefonici possono servirci per contattarti in caso di domande. Il tuo contatto cellulare ci dà la possibilità di inviarti un SMS gratuito per avvisarti della consegna della merce.': 'Vaše telefonní číslo nám umožní vás kontaktovat v případě dotazů. Kontakt na váš mobil nám umožní poslat vám bezplatnou SMS, abychom vám oznámili dodání zboží.',
    'I want to receive the invoice': 'Přeji si vystavit fakturu',
    'Identical to shipping address': 'Stejná jako dodací',
    'Insert here coupon code': 'Sem zadejte slevový kód',
    'Insert here the shipping data': 'Sem zadejte dodací údaje',
    'Insert here your email to proceed, we will send you just the order updates': 'Než budete pokračovat, zadejte sem e-mail. Budeme vám posílat pouze informace k této objednávce',
    'Insert your billing address': 'Upišite svoju adresu za fakturiranje',
    'invoice': 'platba',
    'Invoice address': 'Fakturační adresa',
    'Last name': 'Příjmení',
    'Lastname': 'Příjmení',
    'Leave': 'Odejít',
    'Loading': 'Nakládání',
    'Loading payment form, please wait': 'Načítá se platební formulář, vyčkejte',
    'login': 'Přihlásit se',
    'Login': 'Přihlašovací jméno',
    'Male': 'Muž',
    'Message': 'Zpráva',
    'Mobile phone': 'Telefonní číslo',
    'Monday': 'ponedjeljak',
    'Move item': 'Přidat položku',
    'Move product': 'Přesuňte produkt',
    'Name': 'Jméno',
    'New address': 'Nová adresa',
    'New client': 'Nový zákazník',
    'No items in cart': 'Košík je prázdný',
    'No near stores': 'Žádné obchody poblíž',
    'No shipping methods available': 'Není k dispozici žádný způsob dopravy',
    'Not registered yet?': 'Nejste ještě zaregistrovaní?',
    'Ok': 'OK',
    'Or': 'Nebo',
    'Order detail': 'Detail objednávky',
    'Order details': 'Detaily objednávky',
    'Order placed': 'Objednávka provedena. Budete přesměrováni na stránku se souhrnem',
    'Order will be shipped to': 'Objednávka bude odeslána na adresu',
    'Our online shop handles payments in Euros.<br> You will then be charged the amount of:': 'Náš internetový obchod přijímá platby v EUR.<br> Bude vám proto účtována částka:',
    'Password': 'Heslo',
    'Password confirm': 'Potvrdit heslo',
    'Pay': 'Zaplatit',
    'payment': 'Platba',
    'Payment': 'Platba',
    'Payment error.': 'Chyba platby.',
    'Payment method': 'Způsob platby',
    'Payment method not supported': 'Platební metoda není podporována',
    'Personal data': 'Osobní údaje',
    'Place of birth': 'Místo narození',
    'Place of Birth': 'Místo narození',
    'Please select shipping from Amazon widget': 'Vyberte dopravu ve widgetu Amazon',
    'Please try again with another form of payment': 'Zkuste to znovu s jinou platební metodou',
    'Please wait': 'Prosím počkejte',
    'Please wait, payment is processing': 'Vyčkejte, platba se zpracovává',
    'Postcode': 'PSČ',
    'Prefix': 'Předpona',
    'Proceed': 'Pokračuj',
    'Proceed delete': 'Pokračovat',
    'Proceed to payment': 'Přikročit k úhradě',
    'Proceed with the purchase': 'Pokračovat s nákupem',
    'product': 'produkt',
    'Product': 'Produkt',
    'products': 'produkty',
    'Products total': 'Celkem produktů',
    'Quantity': 'Množství',
    'Register': 'Registrovat se',
    'Registered User': 'Registrovaný Uživatel',
    'Registration agreement': 'Podmínky registrace',
    'Registration successful': 'Registrace úspěšná',
    'registrationagreement': 'Přijímám <a href="{linkfid}" target="_blank">podmínky věrnostního programu</a> a <a href="{linkpriv}" target="_blank">zásady ochrany osobních údajů</a>',
    'Remove': 'Odebrat',
    'Remove Discount': 'Odebrat slevu',
    'Remove the item': 'Odebrat položku',
    'Required fields': 'Povinná pole',
    'Retry': 'Zkusit znovu',
    'review': 'souhrn',
    'Safe purchase': 'Bezpečný nákup',
    'Same as billing': 'Stejné jako fakturační adresa',
    'Saturday': 'subota',
    'Save': 'Uložit',
    'Save address': 'Uložit adresu',
    'Save in address book': 'Uložit do adresáře',
    'Save new address to proceed': 'Pokračujte uložením nové adresy',
    'Select': 'Vybrat',
    'Select a city': 'Vybrat město',
    'Select a payment method': 'Vyberte způsob platby',
    'Select a region': 'Vybrat oblast',
    'Select an address': 'Vybrat adresu',
    'Select here your shipping address': 'Zde vyberte dodací adresu',
    'Select payment method': 'Vyberte způsob platby',
    'Select region': 'Vyberte oblast',
    'Select shipping method': 'Vyberte způsob dopravy',
    'Select store pickup': 'Vyberte vyzvednutí v obchodě',
    'Select store pickup to precede': 'Pokračujte výběrem vyzvednutí v prodejně',
    'Select the store': 'Vyberte obchod',
    'Select this store': 'Odaberi ovu trgovinu',
    'Select value': 'Vyberte hodnotu',
    'Selected Store': 'Vybraný obchod',
    'Seleziona il metodo di spedizione': 'Vyberte způsob dopravy',
    'Send remainder': 'Poslat e-mail pro obnovu hesla',
    'Service unavailable, retry later': 'Dočasná chyba během vyřizování požadavku, zkuste to později',
    'Session expired, page will reload': 'Vypršela platnost relace, stránka se obnoví',
    'shipping': 'Doprava',
    'Shipping': 'Doprava',
    'Shipping address': 'Dodací adresa',
    'Shipping and handling': 'Doprava a manipulace',
    'Shipping data': 'Datum odeslání',
    'Shipping informations': 'Dodací údaje',
    'Shop opening hours': 'Prikaži radne sate',
    'Shopping Cart': 'Košík',
    'shopping details': 'podrobnosti nákupu',
    'Size': 'Velikost',
    'Something went wrong during Yandex Checkout': 'Došlo k problému ve službě Yandex Checkout',
    'State/Region': 'Okres',
    'Store selection': 'Vybrat obchod',
    'street': 'ulice',
    'Street': 'Ulice',
    'Street number': 'Číslo popisné',
    'Sunday': 'nedjelja',
    'Surname': 'Příjmení',
    'Tax included': 'Včetně daně',
    'Telephone': 'Telefon',
    'Telephone number': 'Telefonní číslo',
    'Telephone number for courier / store pickup': 'Telefonní číslo pro kurýr / vyzvednutí na prodejně',
    'Terranova stores near you': 'Prodejny Terranova ve vašem okolí',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Kupon je neplatný. Zkontrolujte kód a zkuste to znovu.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'Dárková karta je neplatná nebo prázdná. Zkontrolujte dárkovou kartu a zkuste to znovu',
    'The maximum value of the usable We+Card bonus is': 'Maximální využitelná hodnota bonusu WE Card je',
    'The maximum value of the usable WE+Card points is': 'Maximální hodnota využitelných bodů WE Card je',
    'The order is already been paid, please wait while order is placing': 'Objednávka již byla uhrazena, vyčkejte po dobu podávání objednávky',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Heslo musí mít délku nejméně 8 znaků a obsahovat velké písmeno, malé písmeno, číslici a speciální znak (.;,!$#).',
    'The requested qty is not available': 'Požadované množství není k dispozici',
    'There has been an error. Please try again': 'Došlo k chybě. Zkuste to znovu',
    'This email already esists. Do the login or proceed as guest': 'Tento e-mail již existuje. Přihlaste se, nebo pokračujte jako host',
    'This product is not available, please remove it from cart to proceed': 'Tento produkt není k dispozici. Než budete pokračovat, odeberte jej z košíku.',
    'Thursday': 'četvrtak',
    'To': 'Do',
    'Total': 'Celkem',
    'Tuesday': 'utorak',
    'Type of card': 'Typ karty',
    'Update address': 'Aktualizovat adresu',
    'Use Glam Card Bonus': 'Použít bonus WE Card',
    'Use points': 'Použít bonus',
    'Use WE+ points': 'Využít body WE Card',
    'User': 'Uživatel',
    'Valid until': 'Platnost do',
    'VAT number': 'DIČ',
    'Verify billing address': 'Ověřit fakturační adresu',
    'Verify Gift Card': 'Ověřte dárkovou kartu',
    'Verify payment method selection': 'Ověřit výběr platební metody',
    'Verify shipping address': 'Ověřit dodací adresu',
    'Verify shipping method selection': 'Ověřit výběr způsobu dopravy',
    'View your cart': 'Prohlédněte si košík',
    'Wait for page to reload': 'Počkejte na opětovné načtení stránky',
    'We\'re unable to send the password reset email': 'Není možné odeslat e-mail pro obnovu hesla. Zkontrolujte přijatou poštu',
    'Wednesday': 'srijeda',
    'You are ordering with this email address': 'Objednáváte na tuto e-mailovou adresu',
    'You are shipping in a foreign country': 'Zvolili jste dopravu do zahraničí',
    'Your available points': 'Vaše dostupné body',
    'Your avalaible bonus': 'Bonusová sleva',
    'Zip code': 'PSČ',
    'Zip or city': 'Zadejte PSČ',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Náklady na dopravu nejsou zahrnuty',
    'Extra address': 'Doplňující informace (volitelné)',
    'Extra address placeholder': 'na adrese, interní, část, jméno na interním telefonu',
    '8 characters': '8 znaků',
    '1 lowercase letter': '1 malé písmeno',
    '1 uppercase letter': '1 velké písmeno',
    '1 number': '1 číslice',
    '1 special character': '1 speciální znak',
    'Now you can use your points': 'Nyní můžete využít své body',
    'Hallo': 'Ahoj',
    'Save Credit Card (One Click Payment)': 'Uložit kreditní kartu (platba jedním kliknutím)',
    'Pay with a saved credit card': 'Plaťte uloženou kreditní kartou',
    'Pay with a new credit or debit card': 'Plaťte novou kreditní nebo debetní kartou',
    'Expiration': 'Vypršení platnosti',
    'Other': 'Ostatní',
    'Applied discounts': 'Uplatněné slevy',
    'Choose size': 'Vyber si velikost',
    'Municipality': 'Obec',
    'amount-for-freeshipping': 'Chybí vám {amount} na dopravu zdarma kurýrem',
    'klarna-threshold-warning': 'Platba s Klarna je možná pouze za minimální částku {amount} eur',
    'To proceed you must select a payment method': 'Chcete-li pokračovat, je nutné vybrat způsob platby',
    'To proceed you need to save the selected billing address': 'Chcete-li pokračovat, je nutné uložit zvolenou fakturační adresu',
    'To proceed it is necessary to accept the general conditions of sale': 'Chcete-li pokračovat, je nutné přijmout všeobecné prodejní podmínky',
    'To proceed you need to select the store': 'Chcete-li pokračovat, je nutné vybrat obchod',
    'To proceed you need to save your changes': 'Chcete-li pokračovat, je nutné uložit změny',
    'Are you sure you want to delete this address?': 'Opravdu chcete tuto adresu odstranit?',
    'To proceed you need to save the selected shipping address': 'Chcete-li pokračovat, musíte uložit vybranou dodací adresu',
    'message-double_optin_using_point_disabled': 'Na tento nákup nelze body uplatnit, protože jste dosud nepotvrdili platnost svého e-mailu nebo telefonního čísla. Máte-li jakékoli dotazy, kontaktujte naši zákaznickou službu.',
}
export default cz;
export const czValidation = {
    name: "cz",
    messages: {
        _default: function (e: any) {
            return "Hodnota pole " + e + " je neplatná."
        },
        after: function (e: any, n: any) {
            return "The " + e + " musí být po " + n[0] + "."
        },
        alpha: function (e: any) {
            return "Pole " + e + " může obsahovat pouze písmena."
        },
        alpha_dash: function (e: any) {
            return "Pole " + e + " může obsahovat alfanumerické znaky, pomlčky a podtržítka."
        },
        alpha_num: function (e: any) {
            return "Pole " + e + " může obsahovat pouze alfanumerické znaky."
        },
        alpha_spaces: function (e: any) {
            return "Pole " + e + " může obsahovat pouze alfanumerické znaky a mezery."
        },
        before: function (e: any, n: any) {
            return "Pole " + e + " musí být před " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "Pole " + e + " musí být mezi " + n[0] + " a " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "Pole " + e + " neodpovídá hodnotě " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "Pole " + e + " je neplatné."
        },
        date_between: function (e: any, n: any) {
            return "Tam " + e + " musí být mezi " + n[0] + " a " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "Tam " + e + " musí být ve formátu " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Pole " + e + " musí být číselné a může obsahovat" + (r && "*" !== r ? " " + r : "") + " desetinné tečky."
        },
        digits: function (e: any, n: any) {
            return "Pole " + e + " musí být číselné a musí mít přesný počet " + n[0] + " míst."
        },
        dimensions: function (e: any, n: any) {
            return "Pole " + e + " musí být " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "Pole " + e + " musí být platná e-mailová adresa."
        },
        excluded: function (e: any) {
            return "Pole " + e + " musí mít platnou hodnotu."
        },
        ext: function (e: any) {
            return "Pole " + e + " musí být platný soubor."
        },
        image: function (e: any) {
            return "Pole " + e + " musí být obrázek."
        },
        included: function (e: any) {
            return "Pole " + e + " musí mít platnou hodnotu."
        },
        ip: function (e: any) {
            return "Pole " + e + " musí být platná IP adresa."
        },
        length: function (e: any, n: any) {
            return "Délka pole " + e + " musí být " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "Pole " + e + " nesmí být delší než " + n[0] + " znaků."
        },
        max_value: function (e: any, n: any) {
            return "Pole " + e + " musí být menší nebo rovné " + n[0]
        },
        mimes: function (e: any) {
            return "Pole " + e + " musí mít platnou hodnotu."
        },
        min: function (e: any, n: any) {
            return "Pole " + e + " může mít minimální počet " + n[0] + " znaků."
        },
        min_value: function (e: any, n: any) {
            return "Pole " + e + " musí být větší nebo rovné " + n[0]
        },
        numeric: function (e: any) {
            return "Pole " + e + " může obsahovat pouze číslice."
        },
        regex: function (e: any) {
            return "Pole " + e + " nemá platný formát."
        },
        required: function (e: any) {
            return "Pole " + e + " je povinné."
        },
        size: function (e: any, n: any) {
            return "Pole " + e + " musí být menší než " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "Pole " + e + " není platná adresa URL."
        },
        'validate-piva-cf': function (e: any) {
            return 'Neplatné DIČ/daňový kód.';
        },
        'validate-regionid': function (e: any) {
            return 'Pole provincie je povinné.';
        },
        'validate-ascii': function(e: any) {
            return 'Zadejte své jméno a příjmení bez zvláštních znaků';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Ke zpracování osobních údajů je vyžadován váš souhlas.';
        },
        'validate-gender': function(e: any) {
            return 'Pole Pohlaví je povinné.';
        },
        'validate-password': function(e: any) {
            return 'Heslo musí mít délku nejméně 8 znaků a obsahovat velké písmeno, malé písmeno, číslici a speciální znak (.;,!$#).';
        },
    },
    attributes: {}
};
